
import {CdkTextareaAutosize} from '@angular/cdk/text-field';
import {Component, NgZone, ViewChild,ElementRef, Inject, Optional, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DebidaDiligencia } from 'app/main/models/debida-diligencia.model';
import { DebidaDiligenciaService } from 'app/main/services/debida-diligencia.service';
import { first,take } from 'rxjs/operators';
import {TranslateService} from '@ngx-translate/core';
import {MatSnackBar} from '@angular/material/snack-bar';
import {FormControl} from '@angular/forms';
import {map, startWith} from 'rxjs/operators';
import {Observable} from 'rxjs';
import { environment } from 'environments/environment';
import { AppConfig } from 'app/app-config';
import { UtilsService } from 'app/main/services/utils.service';
import { TablaDeEvaluacion } from 'app/main/models/tabla-de-evaluacion.model';
import { Sentencia } from 'app/main/models/sentencia.model';

@Component({
  selector: 'app-analisis-dialog-analytics-comparator-box',
  templateUrl: './dialog-analisis-analytics-comparator-box.component.html',
  styleUrls: ['./dialog-analisis-analytics-comparator-box.component.scss']
})
export class DialogAnalisisComparatorBoxAnalyticsComponentDebidaDiligencia {

  DebidaDiligencia: DebidaDiligencia[] = [];
  action: string;
  sentencia: Sentencia;
  sentenciasList: Sentencia[] = [];
  tablaDeDebidaDiligencia: TablaDeEvaluacion;
  displayedColumns: string[] = ['nombre', 'descripcion','respuesta'];

  functionKeys: string[] = [];
  functionKeys2: string[] = [];

  organizacion : string;
  fecha: Date = new Date();
  disabled : boolean = false;
  esMatrizMultidimendionalPorNombre: boolean =false;
  nivel: number = 0;
  esMultiple: boolean = false;
  esMatrizReverso: boolean = false;
  matriz:any = {};
  matrizPromedio:any = {};
  matrizMultidimensional:any = {};
  matrizSimple:any = {};

  matrizMultidimendionalPorNombre:any = {}
  matrizMultidimendionalPorAno:any = {}

  matrizPromedioKeys:string[] = [];
  matrizMultidimensionalKeys:string[] =[];
  matrizMultidimensionalbyFunctionKeys:any ={};
  matrizMultidimensionalbyFunctionKeysByGoup:any = {};
  matrizSimpleKeys:string[] =[];
  matrizValores:string[]=[""];
  


  cantidadHojas: number =0;
  esPromedio: boolean = false;

  single: any[] =[];
  multi: any[] = [];
  multiPorNombre: any[] = [];
  view: any[] = [1200, 400];

  // options
  showXAxis = true;
  showYAxis = true;
  gradient = false;
  showLegend = true;
  showXAxisLabel = true;
  xAxisLabel = 'Categoria';
  showYAxisLabel = true;
  yAxisLabel = 'Promedio';

  // colorScheme = {
  //   domain: ['#5AA454', '#A10A28', '#C7B42C', '#AAAAAA']
  // };

  constructor(
    private _ngZone: NgZone,
    private service: DebidaDiligenciaService,
    public dialogRef: MatDialogRef<DialogAnalisisComparatorBoxAnalyticsComponentDebidaDiligencia>,
    public translate: TranslateService,
    private _snackBar: MatSnackBar,
    private utils: UtilsService,
    private appConfig:AppConfig,
    //private _fuseProgressBarService: FuseProgressBarService,

    // @Optional() is used to prevent error if no data is passed
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any) {
    console.log(data);
    this.sentenciasList = data.sentenciasList;
    this.organizacion = appConfig.cliente;
    this.tablaDeDebidaDiligencia = data.sentenciasList[0].tablaDeDebidaDiligencia;
  }


  

  closeDialog(): void{
    this.dialogRef.close({event: 'Cancel'});
  }

  ngOnInit(): void {

    //Load analisis de brechas completo.
    for(var i=0; i< this.sentenciasList.length;i++){
      this.service.get(this.sentenciasList[i].id).pipe().subscribe(req => {
        var analisisDeBrecha = new DebidaDiligencia(req.body);
        this.DebidaDiligencia.push(analisisDeBrecha);
        if(this.DebidaDiligencia.length == this.sentenciasList.length){
          this.loadData();
        }

    });
   }

    if(this.tablaDeDebidaDiligencia.subtipo=="CUMPLE_NO_CUMPLE"
      ){
        this.esPromedio = true;
      }

  }

  loadData(){

    for(var z=0; z<this.DebidaDiligencia.length;z++){

      this.esMatrizMultidimendionalPorNombre = true;

      this.matrizMultidimendionalPorAno[this.DebidaDiligencia[z].nombre] = {};
      for(var i=0; i< this.DebidaDiligencia[z].formulario.sentencias.length;i++){
        var nombreFuncion = this.DebidaDiligencia[z].formulario.sentencias[i].nombre;
        this.matrizMultidimendionalPorAno[this.DebidaDiligencia[z].nombre][nombreFuncion] = {
                                                                data:{},
                                                                multi: [],
                                                                cantidadHojas:0,
                                                                matrizPromedio:{},
                                                                matrizPromedioKeys:{}};
        //this.sumarSimplePorNombre(this.DebidaDiligencia[z].formulario.sentencias[i].sentencias,this.matrizMultidimendionalPorAno[this.DebidaDiligencia[z].nombre][nombreFuncion]);
        this.hacerPromediosSegunTotalNodoPorNombre(this.matrizMultidimendionalPorAno[this.DebidaDiligencia[z].nombre][nombreFuncion]);
      }

      this.hacerGraficaTotalPorNombre(this.matrizMultidimendionalPorAno[this.DebidaDiligencia[z].nombre]);
      console.log(this.matrizMultidimendionalPorAno);
    }

    this.hacerGraficaTotalPorNombreAgrupado();

  }

  //Se suma todas las hojas, se genera solo 1 tabla simple por opciones
  sumarSimplePorNombre(sentencias:Sentencia[],matriz:any):void{

    for(var i=0; i<sentencias.length;i++){

      //Es hoja?
      if(sentencias[i].sentencias==null || sentencias[i].sentencias.length==0){
        matriz.cantidadHojas+=1;
        if(sentencias[i].valores.length>0)
          sentencias[i].valores.forEach(valor => {
            this.agregarSimplePorNombre(valor.opcion.nombre,valor.valor,valor.cumpleNoCumple,matriz);
          });
        else if(sentencias[i].sentencias.length==0 && sentencias[i].valores.length==0 &&
          sentencias[i].opcion!=null){
            this.agregarSimplePorNombre(sentencias[i].opcion.nombre,1,false,matriz);
            continue;
          }
      }else{
        this.sumarSimplePorNombre(sentencias[i].sentencias,matriz);
      }
    }
  }

  agregarSimplePorNombre(nombre,valor,cumpleNoCumple,matriz){

    //Si es cumple No cumple y es true, suma 1.
    if(this.esPromedio  && cumpleNoCumple)
      valor = 1;

    //Si nunca se cargo, se inicializa
    if(matriz.data[nombre]==undefined)
      matriz.data[nombre]=0;

    matriz.data[nombre] += valor;
    matriz.data = {...matriz.data};

  }

  agregarPorGrupo(nombreNivel,nombre,valor){
    
    if(this.matrizMultidimensional[nombreNivel]==undefined)
      this.matrizMultidimensional[nombreNivel]={};

    if(this.matrizMultidimensional[nombreNivel][nombre]==undefined)
      this.matrizMultidimensional[nombreNivel][nombre]=0;
    
      this.matrizMultidimensional[nombreNivel][nombre]+=valor;
    
  }

  //Se hacen los promedios segun la cantidad de nodos hijos encontrados
  hacerPromediosSegunTotalNodoPorNombre(matriz){
    
    for (let key in matriz.data) {
      let value = matriz.data[key];
      var promedio = value/matriz.cantidadHojas;
      if(this.esPromedio)
        promedio = promedio * 100;
      matriz.matrizPromedio[key] = promedio;//{valor: value, promedio: promedio};

    }
    matriz.matrizPromedioKeys = Object.keys(matriz.matrizPromedio);
    this.matrizPromedioKeys = Object.keys(matriz.matrizPromedio);
    
  }


  hacerGraficaTotalPorNombre(matriz:any){
    for(let key in matriz){
      let matriz2 = matriz[key].matrizPromedio;
      var multiItem = {"name":key,"series":[]};
      for (let key2 in matriz2) {
        if(matriz[key].matrizPromedio[key2]!= undefined)
          multiItem["series"].push({
                            "name": key2,
                            "value": matriz[key].matrizPromedio[key2]
                          });
        if(this.functionKeys2.indexOf(key2) ==-1)
        this.functionKeys2.push(key2);
        
      }
      matriz[key].multi.push(multiItem);
      if(this.functionKeys.indexOf(key) ==-1)
        this.functionKeys.push(key);
    }
  }

  hacerGraficaTotalPorNombreAgrupado(){
    

    for(var i=0; i<this.functionKeys.length;i++){
      var name = this.functionKeys[i];
      this.matrizMultidimensionalbyFunctionKeys[name] = {x:[],
                                                         y:[]};
      
      for(let key in this.matrizMultidimendionalPorAno){
        let matriz2 = this.matrizMultidimendionalPorAno[key][name].matrizPromedio;
        var multiItem = {"name":key,"series":[]};
        for (let key2 in matriz2) {
          if(this.matrizMultidimendionalPorAno[key][name].matrizPromedio[key2]!=undefined)
            multiItem["series"].push({
                              "name": key2,
                              "value": this.matrizMultidimendionalPorAno[key][name].matrizPromedio[key2]
                            });
          
        }
        this.matrizMultidimensionalbyFunctionKeys[name]["x"].push(multiItem);
      }

      for(var j=0; j<this.functionKeys2.length;j++){
        var key = this.functionKeys2[j];
        this.matrizMultidimensionalbyFunctionKeys[name]["y"].push({"name":key,"series":[]});
      }
    }

    for(var i=0; i<this.functionKeys2.length;i++){
      var name = this.functionKeys2[i];
      
      for(let key in this.matrizMultidimendionalPorAno){
        var multiItem = {"name":name,"series":[]};
        for(let key2 in this.matrizMultidimendionalPorAno[key]){
          //multiItem["series"].push();
          for(var f=0; f< this.matrizMultidimensionalbyFunctionKeys[key2]["y"].length;f++){
            if(this.matrizMultidimensionalbyFunctionKeys[key2]["y"][f].name==name && 
                this.matrizMultidimendionalPorAno[key][key2].matrizPromedio[name])
              this.matrizMultidimensionalbyFunctionKeys[key2]["y"][f].series.push({
                "name": key,
                "value": this.matrizMultidimendionalPorAno[key][key2].matrizPromedio[name]
              });
          }
        }
      }
    }

    
    for(var j=0; j<this.functionKeys2.length;j++){
      this.matrizMultidimensionalbyFunctionKeysByGoup[this.functionKeys2[j]] = [];
      for(var i=0; i<this.functionKeys.length;i++){
        var name = this.functionKeys[i];
        var multiItem = {"name":name,"series":[]};
        for(let key in this.matrizMultidimendionalPorAno){
          if(this.matrizMultidimendionalPorAno[key][this.functionKeys[i]].matrizPromedio[this.functionKeys2[j]]!=undefined)
            multiItem["series"].push({
                              "name": key,
                              "value": this.matrizMultidimendionalPorAno[key][this.functionKeys[i]].matrizPromedio[this.functionKeys2[j]]
                            });
          
        }
        this.matrizMultidimensionalbyFunctionKeysByGoup[this.functionKeys2[j]].push(multiItem);
      }
    }

    console.log(this.matrizMultidimensionalbyFunctionKeysByGoup);

    
  }

  calcularPorNivel(sentencias:Sentencia[],nivel:number):void{

    sentencias.forEach(function(sentencia){
      if(nivel ==0){
        
      }
    });

  }



  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 3000,
    });
  }

  public printPdf()
  {
    this.disabled=true;
    this.utils.printPdf();
    this.disabled=false;

  }

}
